import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';

interface UpdateUserDetailsVariables {
    teamId: string;
    userId: string;
    details: {
        given_name: string;
        family_name: string;
    };
}

interface UpdateTeamRoutingPlansResponse {
    message: string;
}

export default function useUpdateUserDetails() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['userDetails'],
    mutationFn: async ({
      teamId,
      userId,
      details,
    }: UpdateUserDetailsVariables) => apiFetch<UpdateTeamRoutingPlansResponse>({
      path: `team/${teamId}/user/${userId}/details`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
      body: {
        given_name: details.given_name,
        family_name: details.family_name,
      },
    }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['teamMembers', { teamId: variables.teamId }],
      });
    },
  });
}
